"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkToggleDevourIQBodyToJSON = exports.BulkToggleDevourIQBodyFromJSONTyped = exports.BulkToggleDevourIQBodyFromJSON = void 0;
function BulkToggleDevourIQBodyFromJSON(json) {
    return BulkToggleDevourIQBodyFromJSONTyped(json, false);
}
exports.BulkToggleDevourIQBodyFromJSON = BulkToggleDevourIQBodyFromJSON;
function BulkToggleDevourIQBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dryRun': json['dryRun'],
        'isEnabled': json['isEnabled'],
    };
}
exports.BulkToggleDevourIQBodyFromJSONTyped = BulkToggleDevourIQBodyFromJSONTyped;
function BulkToggleDevourIQBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dryRun': value.dryRun,
        'isEnabled': value.isEnabled,
    };
}
exports.BulkToggleDevourIQBodyToJSON = BulkToggleDevourIQBodyToJSON;
